export default __webpack_public_path__ + "9d0f4870d8e0a025de631f01e8c977a2.json";